import { leseCookieWert, ermittleAbholungCta } from "../../common/abholungCta";

class KaufenContainer extends HTMLElement {
  connectedCallback() {
    if (this.hasOneCTA()) {
      if (this.isFilialabholung()) {
        this.querySelector(".stock-indicator").remove();
      } else {
        this.querySelector(".stock-indicator").classList.remove("hidden");
      }
    } else {
      if (this.hasFilialabholungAsSecondary()) {
        this.setFilialStockIndicator();
      } else {
        this.getStockIndicatorFromPrimary();
      }
    }

    this.initEventHandler();
    this.initZurAbholungBestellenCta();
    // Filialwechsel ohne Reload: das LieAS-Snippet laedt die Abholaussage neu und meldet sich hier zurueck,
    // dann werden CTA und Akkordeon-Header mit dem frischen Verfuegbarkeits-Status neu bewertet.
    // signal: beim Entfernen/Verschieben des Elements wird der Listener sauber abgemeldet (kein Doppeln bei Reconnect).
    this.abholaussageListenerController = new AbortController();
    this.addEventListener(
      "abholaussage-aktualisiert",
      () => this.aktualisiereNachAbholaussage(),
      { signal: this.abholaussageListenerController.signal },
    );
  }

  aktualisiereNachAbholaussage() {
    this.initZurAbholungBestellenCta();
    if (this.hasFilialabholungAsSecondary()) {
      this.setFilialStockIndicator();
    }
  }

  disconnectedCallback() {
    this.abholaussageListenerController?.abort();
  }

  // Split: BES rendert den "Zur Abholung bestellen"-Button. filialId ist nicht serverseitig bekannt
  // (Snippet pro matnr gecacht) -> aus dem Cookie ergaenzen; Button nur zeigen, wenn eine Filiale gewaehlt ist
  // und die Abholaussage nicht "nicht verfuegbar" meldet.
  initZurAbholungBestellenCta() {
    const form = this.querySelector("form.zur-abholung-bestellen");
    if (!form) {
      return;
    }
    // Bewusst nur temp_abholfiliale + abholfiliale (wie LieAS CookieHelper.getAbholfiliale und die FAS-Standortbox):
    const filialId = leseCookieWert(document.cookie, "temp_abholfiliale")
      || leseCookieWert(document.cookie, "abholfiliale");
    const verfuegbarkeitStatus = this.getAbholaussageState();
    const filialabholungMoeglich = this.getFilialabholungMoeglich();
    const { action, sichtbar } = ermittleAbholungCta(form.getAttribute("action"), filialId, verfuegbarkeitStatus, filialabholungMoeglich);
    form.setAttribute("action", action);
    form.hidden = !sichtbar;
  }

  getAbholaussageIndicator() {
    return this.querySelector("filial-abholaussage .element-status-indicator");
  }

  // Abholaussage-Status (data-state) aus dem LieAS-Snippet; steuert mit, ob der CTA sichtbar ist.
  getAbholaussageState() {
    const indicator = this.getAbholaussageIndicator();
    return indicator ? (indicator.getAttribute("data-state") || "").trim() : null;
  }

  // Filialabholbarkeit (data-filialabholung-moeglich) aus dem LieAS-Snippet: true/false, oder null wenn
  // das Attribut fehlt (Snippet noch nicht geladen) -> dann kein Ausschluss des CTA.
  getFilialabholungMoeglich() {
    const indicator = this.getAbholaussageIndicator();
    if (!indicator || !indicator.hasAttribute("data-filialabholung-moeglich")) {
      return null;
    }
    return indicator.getAttribute("data-filialabholung-moeglich").trim() === "true";
  }

  initEventHandler() {
    this.showPrimary = this.querySelector('[interaction="show-primary"]');
    this.showSecondary = this.querySelector('[interaction="show-secondary"]');
    this.primaryPrice = document.querySelector('artikel-preis .artikel-preis-wrapper');
    this.secondaryPrice = this.querySelector('[data-pricebox="secondary-price"]');
    this.abokaufenPrice = document.querySelector('abokaufoption-preis');
    this.primaryInput = this.querySelector('[interaction="show-primary"] input[type=radio]');
    this.primaryContent = this.querySelector(".toggle-container-primary");
    this.secondaryInput = this.querySelector('[interaction="show-secondary"] input[type=radio]');
    this.secondaryContent = this.querySelector(".toggle-container-secondary");

    if (this.showPrimary === null || (this.showSecondary === null && this.abokaufenPrice === null)) return;

    // click on primary option
    this.showPrimary.addEventListener("click", (event) => {
      //toggle prices
      if(this.primaryPrice && this.secondaryPrice) {
        this.primaryPrice.style.display = "block";
        this.secondaryPrice.style.display = "none";
      }

      // accessibility logic
      this.primaryInput.setAttribute("aria-expanded", true);
      this.secondaryInput.setAttribute("aria-expanded", false);
      this.primaryInput.setAttribute("checked", true);
      this.secondaryInput.removeAttribute("checked");
      this.primaryContent.hidden = false;
      this.secondaryContent.hidden = true;
    })

    // click on secondary option
    this.secondaryInput.addEventListener("change", (event) => {
      //toggle prices
      if(this.primaryPrice && this.secondaryPrice) {
        this.primaryPrice.style.display = "none";
        this.secondaryPrice.style.display = "block";
      }

      // accessibility logic
      this.primaryInput.setAttribute("aria-expanded", false);
      this.secondaryInput.setAttribute("aria-expanded", true);
      this.primaryInput.removeAttribute("checked");
      this.secondaryInput.setAttribute("checked", true);
      this.primaryContent.hidden = true;
      this.secondaryContent.hidden = false;

      if(!(this.cookieExistiert("temp_abholfiliale") || this.cookieExistiert("such_abholfiliale") || this.cookieExistiert("abholfiliale"))) {
        this.edit = this.querySelector(".filiale-aendern");
        if(this.edit) {
          this.edit.click();
        }
      }
    })
  }

  cookieExistiert(name) {
    return !!document.cookie
      .split(';')
      .filter((item) => item
        .includes(name)).length;
  }

  hasOneCTA() {
    if (this.querySelector(".kaufen-aktion-solo")) {
      return true;
    }
  }

  isFilialabholung() {
    // NEU: FAS-Element <bestelleinstieg-standort>
    if (this.querySelector("bestelleinstieg-standort")) {
      return true;
    }
    // ABHOLUNG_SPLIT_SNIPPET (Cutover) – ENTFERNEN ANFANG: alte FAS-Box <filialabholung-box>
    if (this.querySelector("filialabholung-box")) {
      return true;
    }
    // ABHOLUNG_SPLIT_SNIPPET (Cutover) – ENTFERNEN ENDE
  }

  hasFilialabholungAsSecondary() {
    // NEU: FAS-Element <bestelleinstieg-standort>
    if (this.querySelector(".kaufen-aktion-secondary bestelleinstieg-standort")) {
      return true;
    }
    // ABHOLUNG_SPLIT_SNIPPET (Cutover) – ENTFERNEN ANFANG: alte FAS-Box <filialabholung-box>
    if (this.querySelector(".kaufen-aktion-secondary filialabholung-box")) {
      return true;
    }
    // ABHOLUNG_SPLIT_SNIPPET (Cutover) – ENTFERNEN ENDE
  }

  getAkkordeonHeader() {
    return this.querySelector(".stock-indicator.secondary");
  }

  getStockIndicatorFromPrimary() {
    const stockIndicator = this.querySelector(".kaufen-aktion-primary .stock-indicator").cloneNode(true);
    this.getAkkordeonHeader().remove();
    this.querySelector(".kaufen-aktion-secondary .cta").appendChild(stockIndicator);
  }

  setFilialStockIndicator() {
    const header = this.getAkkordeonHeader();
    if (!header) {
      return;
    }
    header.textContent = "";
    header.classList.remove("underline");

    const indicator = this.getAbholaussageIndicator()
      // ABHOLUNG_SPLIT_SNIPPET (Cutover) – ENTFERNEN: alte FAS-Box mit .abholinfo
      || this.querySelector(".abholinfo");
    const abholaussageText = indicator?.querySelector(".abholinfo-text")?.innerHTML;

    if (this.getFilialabholungMoeglich() === false || !abholaussageText) {
      this.zeigePlatzhalterImHeader(header);
      return;
    }

    header.appendChild(document.createTextNode(abholaussageText));
    header.setAttribute("data-state", indicator.getAttribute("data-state") || "neutral");
  }

  // "Verfuegbarkeit in Ihrer Filiale pruefen" als Header-Platzhalter (kein/ungueltiger Standort gewaehlt).
  zeigePlatzhalterImHeader(header) {
    header.textContent = this.getStockIndicatorPlaceholderText();
    header.classList.add("underline");
    header.setAttribute("data-state", "neutral");
  }

  getStockIndicatorPlaceholderText() {
    const label = this.querySelector(".kaufen-aktion-secondary label");
    return label?.getAttribute("stock-indicator-placeholder") || "Verfügbarkeit in Ihrer Filiale prüfen";
  }
}

if (!customElements.get("kaufen-container")) {
  customElements.define("kaufen-container", KaufenContainer);
}
